module.exports = __webpack_public_path__ + "img/payment.06621f37.svg";